import * as React from 'react';
import { Route } from 'react-router-dom';
import { Home } from './Home';

export const getWebsiteHomeRoutes = (): React.ReactNode => <Route index element={<Home />} />;
